module.exports = __webpack_public_path__ + "static/media/bdsp-marathon.b5970a92.png";